export default class PsConfig {

    static versionNo: String = '1.0';
      
    static apiKey: String = "Meyaku";
    // static fixedDomain: String = "http://localhost/";
    static fixedDomain: String = "https://backoffice.meyaku.com";

//    static domain: String = "http://localhost/";
    static domain: String = "https://backoffice.meyaku.com";

    static firebaseConfig = {
        apiKey: "AIzaSyC_0l2Nt5ZNZrZUkcAvnZzPvHdm69_Y67A",
        authDomain: "meyaku-app.firebaseapp.com",
        projectId: "meyaku-app",
        storageBucket: "meyaku-app.appspot.com",
        messagingSenderId: "423077806071",
        appId: "1:423077806071:web:60b2b19821bf40f73e78f2",
        measurementId: "G-LVBPG8TB4K"
    };

    ///
    /// Base URL * Don't update it *
    ///
    static base: String = PsConfig.domain;
    static baseUrl: String = PsConfig.domain + '/index.php';
    static fixedPath: String = PsConfig.fixedDomain;


    /// Google Map Key
    /// ----------------
    static mapKey: String = "AIzaSyDp0YPClQ7N4h2sOzuzChSmMWajpUC0OIo";


    ///
    /// Price Format
    /// -----------------
    /// Need to change according to your format that you need
    /// E.g.
    /// "#,##0.00"   => 2,555.00
    /// "##0.00"    => 2555.00
    /// "#.00"       => 2555.00
    /// "#,###."      => 2,555
    /// "#,##0.0"    => 2555.0
    /// "###"        => 255
    // #,##0.0
    static priceFormat: string = '#,##0.0';


    ///
    /// Profile Setting for Item Grid
    /// You can hide/show user profile at item grid
    /// true == show user profile
    /// false == hide user profile
    ///
    static showUserProfile: string = 'show';


    ///
    /// Map Filter Setting
    ///
    static noFilterWithLocationOnMap: Boolean = false;

    ///
    /// Promotion Date Pre-define Set
    ///
    /// Type 1 == Fixed Date, Type 2 == Custom Date with user input
    static promotionDays = [
        {
            id: "1", days: 7, type: 1
        },
        {
            id: "2", days: 14, type: 1
        },
        {
            id: "3", days: 30, type: 1
        },
        {
            id: "4", days: 60, type: 1
        },
        {
            id: "5", days: 1, type: 2
        }
    ];

    ///
    /// Default Mile for Nearest Search
    ///
    static mile = "8";

    ///
    /// For default language change, please check
    /// LanguageFragment for language code and country code
    /// ..............................................................
    /// Language             | Language Code     | Country Code
    /// ..............................................................
    /// "English"            | "en"              | "US"
    /// "Arabic"             | "ar"              | "DZ"
    /// "India (Hindi)"      | "hi"              | "IN"
    /// "German"             | "de"              | "DE"
    /// "Spainish"           | "es"              | "ES"
    /// "French"             | "fr"              | "FR"
    /// "Indonesian"         | "id"              | "ID"
    /// "Italian"            | "it"              | "IT"
    /// "Japanese"           | "ja"              | "JP"
    /// "Korean"             | "ko"              | "KR"
    /// "Malay"              | "ms"              | "MY"
    /// "Portuguese"         | "pt"              | "PT"
    /// "Russian"            | "ru"              | "RU"
    /// "Thai"               | "th"              | "TH"
    /// "Turkish"            | "tr"              | "TR"
    /// "Chinese"            | "zh"              | "CN"
    /// ..............................................................
    ///
    static defaultLanguage = {
        languageCode: 'fr',
        countryCode: 'FR',
        name: 'French FR',
        flag: require('@/assets/flags/frenchFlag.jpg')
    };
    static supportedLanguages = [
        { languageCode: 'en', countryCode: 'US', name: 'English US', flag: require('@/assets/flags/usflag.png') },
        // { languageCode : 'ar', countryCode : 'DZ', name : 'Arabic', flag: require('@/assets/flags/dzFlag.png')},
        // { languageCode : 'hi', countryCode : 'IN', name : 'Hindi', flag: require('@/assets/flags/inFlag.jpeg')},
        // { languageCode : 'de', countryCode : 'DE', name : 'German', flag: require('@/assets/flags/germanFlag.jpg')},
        // { languageCode : 'es', countryCode : 'ES', name : 'Spainish', flag: require('@/assets/flags/spainFlag.jpg')},
        { languageCode: 'fr', countryCode: 'FR', name: 'French', flag: require('@/assets/flags/frenchFlag.jpg') },
        // { languageCode : 'id', countryCode : 'ID', name : 'Indonesian', flag: require('@/assets/flags/indonesiaFlag.jpg')},
        // { languageCode : 'it', countryCode : 'IT', name : 'Italian', flag: require('@/assets/flags/italyFlag.jpg')},
        // { languageCode : 'ja', countryCode : 'JP', name : 'Japanese', flag: require('@/assets/flags/japanFlag.jpg')},
        // { languageCode : 'ko', countryCode : 'KR', name : 'Korean', flag: require('@/assets/flags/southkoreaFlag.jpg')},
        // { languageCode : 'ms', countryCode : 'MY', name : 'Malay', flag: require('@/assets/flags/malaysiaFlag.jpg')},
        // { languageCode : 'pt', countryCode : 'PT', name : 'Potuguese', flag: require('@/assets/flags/potugueseFlag.jpg')},
        // { languageCode : 'ru', countryCode : 'RU', name : 'Russian', flag: require('@/assets/flags/russiaFlag.jpg')},
        // { languageCode : 'th', countryCode : 'TH', name : 'Thai', flag: require('@/assets/flags/thaiFlag.jpg')},
        // { languageCode : 'tr', countryCode : 'TR', name : 'Turkish', flag: require('@/assets/flags/turkishFlag.jpg')},
        // { languageCode : 'zh', countryCode : 'CN', name : 'Chinese', flag: require('@/assets/flags/chinaFlag.jpg')}
    ];


    ///
    /// Debug Mode
    ///
    static isDebugMode: Boolean = false;
}
